import React from 'react';

export default function ListagemVertical({ 
  items, 
  loading, 
  onItemClick, 
  renderItem, 
  emptyMessage = "Nenhum item encontrado",
  loadingMessage = "Carregando..."
}) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
        <div className="loading-spinner" style={{ 
          width: '40px', 
          height: '40px', 
          border: '4px solid #f3f3f3', 
          borderTop: '4px solid #3498db', 
          borderRadius: '50%', 
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }}></div>
        <p>{loadingMessage}</p>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
        <i className="fas fa-inbox" style={{ fontSize: '4rem', marginBottom: '20px', color: '#bdc3c7' }}></i>
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="obras-grid">
      {items.map((item, index) => (
        <div 
          key={item.id || index}
          className="obra-card"
          onClick={() => onItemClick && onItemClick(item)}
          style={{ cursor: onItemClick ? 'pointer' : 'default' }}
        >
          {renderItem(item)}
        </div>
      ))}
    </div>
  );
}